/* global axios */
import ApiClient from './ApiClient';

class FunnelsAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  // Obter templates de funil
  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }

  // Criar funil a partir de template
  createFromTemplate(templateType, customizations = {}) {
    return axios.post(`${this.url}/from_template`, {
      template_type: templateType,
      customizations,
    });
  }

  // Stage Management
  addStage(funnelId, stageData) {
    return axios.post(`${this.url}/${funnelId}/stages`, stageData);
  }

  updateStage(funnelId, stageName, stageData) {
    return axios.patch(
      `${this.url}/${funnelId}/stages/${stageName}`,
      stageData
    );
  }

  deleteStage(funnelId, stageName) {
    return axios.delete(`${this.url}/${funnelId}/stages/${stageName}`);
  }

  reorderStages(funnelId, stageOrder) {
    return axios.put(`${this.url}/${funnelId}/stages/reorder`, {
      stage_order: stageOrder,
    });
  }

  // Analytics
  getAnalytics(funnelId, params = {}) {
    return axios.get(`${this.url}/${funnelId}/analytics`, { params });
  }

  getConversionRates(funnelId, params = {}) {
    return axios.get(`${this.url}/${funnelId}/conversion_rates`, { params });
  }

  // Bulk Operations
  bulkMoveConversations(conversationIds, targetFunnelId, targetStage) {
    return axios.post(`${this.url}/bulk_move`, {
      conversation_ids: conversationIds,
      target_funnel_id: targetFunnelId,
      target_stage: targetStage,
    });
  }

  // Import/Export
  exportFunnel(funnelId, format = 'json') {
    return axios.get(`${this.url}/${funnelId}/export`, {
      params: { format },
      responseType: 'blob',
    });
  }

  importFunnel(funnelData, options = {}) {
    return axios.post(`${this.url}/import`, {
      funnel_data: funnelData,
      options,
    });
  }

  // Duplicate
  duplicate(funnelId, newName) {
    return axios.post(`${this.url}/${funnelId}/duplicate`, { name: newName });
  }
}

export default new FunnelsAPI();
